import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import LegalModal from './LegalModal';
import './Footer.css';

function Footer({ onPlaquetteClick }) {
  const currentYear = new Date().getFullYear();
  const [legalModal, setLegalModal] = useState({ isOpen: false, type: null });

  const openLegalModal = (type) => {
    setLegalModal({ isOpen: true, type });
  };

  const closeLegalModal = () => {
    setLegalModal({ isOpen: false, type: null });
  };

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__main">
          <div className="footer__brand">
            <img src="/images/logo-procumatcher.png" alt="ProcuMatcher" className="footer__logo" />
            <p className="footer__tagline">
              Le logiciel de simplification des procurations électorales.
            </p>
          </div>
          
          <div className="footer__links">
            <div className="footer__column">
              <h4>Navigation</h4>
              <ul>
                <li><a href="#features">Fonctionnalités</a></li>
                <li><a href="#how-it-works">Comment ça marche</a></li>
                <li><a href="#stats">Références</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4>Ressources</h4>
              <ul>
                <li>
                  <a href="https://demo.procumatcher.fr" target="_blank" rel="noopener noreferrer">
                    Démo en ligne
                    <ExternalLink size={14} />
                  </a>
                </li>
                <li>
                  <button 
                    className="footer__legal-btn"
                    onClick={onPlaquetteClick}
                  >
                    Plaquette PDF
                  </button>
                </li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4>Légal</h4>
              <ul>
                <li>
                  <button 
                    className="footer__legal-btn" 
                    onClick={() => openLegalModal('ml')}
                  >
                    Mentions légales
                  </button>
                </li>
                <li>
                  <button 
                    className="footer__legal-btn" 
                    onClick={() => openLegalModal('pdc')}
                  >
                    Politique de confidentialité
                  </button>
                </li>
                <li>
                  <button 
                    className="footer__legal-btn" 
                    onClick={() => openLegalModal('cgu')}
                  >
                    CGU
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer__legal">
          <p>
            ProcuMatcher est un logiciel breveté et déposé à l'INPI, invention et propriété de la société{' '}
            <a href="https://www.rodium.fr" target="_blank" rel="noopener noreferrer">Rodium</a>.
          </p>
          <p>
            Une décision du Conseil d'État (n°499193) a confirmé le caractère remboursable de ProcuMatcher au titre des comptes de campagne.
          </p>
        </div>
        
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} ProcuMatcher. Tous droits réservés.
          </p>
        </div>
      </div>

      {/* Legal Modal */}
      <LegalModal 
        type={legalModal.type}
        isOpen={legalModal.isOpen}
        onClose={closeLegalModal}
      />
    </footer>
  );
}

export default Footer;
